import React, { FC, useCallback } from 'react';
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  EmmaButton,
  EmmaSpace,
} from '@axa-asia/emma-stylesheet';
import { useSelector } from 'react-redux';
import {
  getAddressOutOfHKDialog,
  getPolicyServiceFormUrl,
} from '../../../selectors/changeAddressSelector';
import { isApp, resolveLocalizedText } from '../../../../../utils';
import classNames from 'classnames';
import { EmmaFactory } from '@axa-asia/hk-emma-js';

type AddressOutOfHKDialogProps = {
  isShow: boolean;
  onClose: () => void;
};

const AddressOutOfHKDialog: FC<AddressOutOfHKDialogProps> = ({
  isShow,
  onClose,
}) => {
  const { title, description, downloadCta, closeCta } = useSelector(
    getAddressOutOfHKDialog,
  );
  const policyServiceFormUrl = useSelector(getPolicyServiceFormUrl);

  const handleOpenPdf = useCallback(() => {
    const url = resolveLocalizedText(policyServiceFormUrl);
    if (isApp()) {
      EmmaFactory.createInstance()
        .then((emma) => {
          emma.instance.goTo(`system/open-pdf?pdfUrl=${url}`);
        })
        .catch((e) => {
          console.error('Error in handleOpenPdf', e);
        });
    } else {
      window.open(url, '_blank');
    }
  }, [policyServiceFormUrl]);

  return (
    <Dialog show={isShow}>
      <DialogHeader>
        <span>{resolveLocalizedText(title)}</span>
      </DialogHeader>
      <DialogBody>
        <div>{resolveLocalizedText(description)}</div>
      </DialogBody>
      <DialogFooter>
        <div className="d-flex flex-column">
          <EmmaButton onClick={handleOpenPdf}>
            {resolveLocalizedText(downloadCta)}
          </EmmaButton>
          <EmmaButton
            className={classNames(EmmaSpace.mt8)}
            outline
            onClick={onClose}
          >
            {resolveLocalizedText(closeCta)}
          </EmmaButton>
        </div>
      </DialogFooter>
    </Dialog>
  );
};

export default React.memo(AddressOutOfHKDialog);
